module.exports = __webpack_public_path__ + "static/home-brain-large-3c6641e955b8ff3d120d91c8938b1ce0.svg";